import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54b5077e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loaderGenerateConfigContent"
}
const _hoisted_2 = { class: "loaderGenerateConfigSelectionArea" }
const _hoisted_3 = { class: "loaderGenerateConfigButtonArea" }
const _hoisted_4 = {
  key: 0,
  class: "loaderGenerateConfigDebugButtonArea"
}

import { InfoFilled } from '@element-plus/icons-vue';
import { computed, Ref, ref, watchEffect, onMounted } from "vue";
import { SparrowGenTaskReqParam, SparrowToolInfo, TaskTypeEnum } from "@/store/modules/task/types";
import { ElMessage, ElTable } from "element-plus";
import { useStore } from "vuex";
import { TaskActions, TaskGetters } from "@/store/modules/task";
import { CreateTaskParam } from "@/api/task";
import { UserGetters } from "@/store/modules/user";
import { CyModuleTreeNode } from '@/store/modules/cyModule/types';
import { CyModuleActions, CyModuleGetters } from '@/store/modules/cyModule';

import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "LoaderGenerateConfig"
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    taskGenerateStatus: {
        type: String,
        required: true,
    }
},
  setup(__props) {

const props = __props;




const store = useStore();
const defaultNode = {
    id: 0,
    name: "",
    label: "",
    description: "",
    isAdmin: false,
    type: 0,
    tip: "",
    parentTypeId: 0,
    level: 0,
    IsAvailable: false,
    children: [],
}
const clickTools: Ref<CyModuleTreeNode> = ref(defaultNode);
const selectedTools: Ref<CyModuleTreeNode[]> = ref([]);
const machineNameStr: Ref<string> = ref("");
const whiteListDirStr: Ref<string> = ref("");
const screenshotInterval: Ref<number> = ref(60);
const recordingDuration: Ref<number> = ref(600);
const isDebug: Ref<boolean> = ref(false);
const sparrowToolListTableRef = ref<InstanceType<typeof ElTable>>();
const selectedProj = computed(() => {
    return store.getters[`task/${TaskGetters.getSelectedProj}`];
});
const userInfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});
const prevSelectedProj = ref(selectedProj.value);
const selectable = computed(() => {
    return selectedProj.value !== "";
});

const moduleTree = computed(() => {
    return store.getters[`cyModule/${CyModuleGetters.getCyModuleTree}`];
});
const isLoading = computed(() => {
    return store.getters[`cyModule/${CyModuleGetters.getCyModuleListLoading}`];
});

watchEffect(() => {
    if (selectedProj.value && selectedProj.value !== "" && selectedProj.value != prevSelectedProj.value) {
        handleClearSelection();
        prevSelectedProj.value = selectedProj.value;
    }
})

const isDisabled = (row: any, index: number) => {
    if (row.name === 'continuousTask' && selectedTools.value.find(tool => tool.name === 'megaTools')) {
        return false
    }
    if (row.name === 'megaTools' && selectedTools.value.find(tool => tool.name === 'continuousTask')) {
        return false
    }

    return !(row.name === "extra") && row.IsAvailable
    // return !(row.name === "camera" || row.name === "primary" || row.name === "extra")
}
const selectFun = (selection: CyModuleTreeNode[], row: CyModuleTreeNode) => {
    clickTools.value = row;
}

const handleSelectionChange = async (tools: CyModuleTreeNode[]) => {
    if (clickTools.value.name === 'mega' && !tools.find(tool => tool.name === 'files')) {
        moduleTree.value.forEach((item: CyModuleTreeNode) => {
            if (item.name === 'primary') {
                item.children?.forEach((item1) => {
                    if (item1.name === 'files') {
                        sparrowToolListTableRef.value?.toggleRowSelection(item1, true)
                        tools.push(item1)
                    }
                })
            }
        })
    }
    if (clickTools.value.name === 'files') {
        tools.forEach((item) => {
            if (item.name === 'mega') {
                sparrowToolListTableRef.value?.toggleRowSelection(item, false)
                tools = tools.filter(tool => tool.name !== 'mega')
            }
        })
    }
    if (clickTools.value.name === 'primary' && selectedTools.value.find(tool => tool.name === "megaTools")) {
        tools.forEach((item) => {
            if (item.name === 'continuousTask') {
                sparrowToolListTableRef.value?.toggleRowSelection(item, false)
                tools = tools.filter(tool => tool.name !== 'continuousTask')
            }
        })
    }
    if (selectedTools.value.find(tool => tool.name === clickTools.value.name) &&
        clickTools.value.name !== "" &&
        clickTools.value.name !== "primary" &&
        clickTools.value.name !== 'megaTools'
    ) {
        moduleTree.value.forEach((item: CyModuleTreeNode) => {
            if (item.name === 'primary') {
                sparrowToolListTableRef.value?.toggleRowSelection(item, false)
                tools.forEach((item1) => {
                    if (item1.name !== "primary") {
                        sparrowToolListTableRef.value?.toggleRowSelection(item1, true)
                    }
                })
                sparrowToolListTableRef.value?.toggleRowSelection(clickTools.value, false)
            }
        })
    }

    clickTools.value = defaultNode;
    selectedTools.value = tools;

    return
}

const handleGenerate = async () => {
    if (selectedTools.value.length === 0) {
        ElMessage.error("请至少选择一个工具!")
        return
    } else if (!selectable.value) {
        ElMessage.error("请选择一个项目!")
        return
    } else if (machineNameStr.value === "") {
        ElMessage.error("请输入主机名!")
        return
    }
    let toolNameList = selectedTools.value.map(toolInfo => toolInfo.name);
    if (toolNameList.includes('continuousTask')) {
        toolNameList.push('megaDown')
    }
    if (toolNameList.includes('primary')) {
        toolNameList = toolNameList.filter((item, index) => item !== 'primary')
    }
    const toolListStr = toolNameList.join(',');
    const reqParam: SparrowGenTaskReqParam = {
        toolList: toolListStr,
        machineNameList: machineNameStr.value,
        whiteListDir: whiteListDirStr.value === "" ? `C:\\Users\\Public\\Documents\\` : whiteListDirStr.value,
        isDebug: isDebug.value,
        screenshotInterval: screenshotInterval.value,
        recordingDuration: recordingDuration.value,
    }

    const createTaskParam: CreateTaskParam = {
        projId: selectedProj.value,
        payload: JSON.stringify(reqParam),
        type: TaskTypeEnum.SparrowGen
    };

    try {
        await store.dispatch(`task/${TaskActions.asyncCreateTask}`, createTaskParam);
    } catch (err) {
        console.error(err)
    }
}

const handleClearSelection = () => {
    if (sparrowToolListTableRef.value) {
        sparrowToolListTableRef.value.clearSelection();
    }
    selectedTools.value = [];
}

onMounted(async () => {
    await store.dispatch(
        `cyModule/${CyModuleActions.asyncGetCyModuleList}`,
        { userId: userInfo.value.id },
    );
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (!_unref(isLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(" 主机名(以,为分隔符) "),
          _createVNode(_component_el_input, {
            modelValue: machineNameStr.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((machineNameStr).value = $event))
          }, null, 8, ["modelValue"]),
          _createTextVNode(" 截图间隔(秒) "),
          _createVNode(_component_el_input, {
            modelValue: screenshotInterval.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((screenshotInterval).value = $event)),
            modelModifiers: { number: true },
            type: "number"
          }, null, 8, ["modelValue"]),
          _createTextVNode(" 录制时长(秒) "),
          _createVNode(_component_el_input, {
            modelValue: recordingDuration.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((recordingDuration).value = $event)),
            modelModifiers: { number: true },
            type: "number"
          }, null, 8, ["modelValue"]),
          _createTextVNode(" 白名单文件夹 "),
          _createVNode(_component_el_input, {
            modelValue: whiteListDirStr.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((whiteListDirStr).value = $event)),
            placeholder: "C:\\Users\\Public\\Documents\\"
          }, null, 8, ["modelValue"]),
          _createTextVNode(" 工具选择 "),
          _createVNode(_unref(ElTable), {
            ref_key: "sparrowToolListTableRef",
            ref: sparrowToolListTableRef,
            data: _unref(moduleTree),
            onSelectionChange: handleSelectionChange,
            "row-key": "name",
            "default-expand-all": "",
            onSelect: selectFun
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                selectable: isDisabled,
                disabled: true
              }),
              _createVNode(_component_el_table_column, {
                align: "left",
                prop: "label",
                label: "模块名称",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.label) + " ", 1),
                  (scope.row.label === '剪切板历史记录')
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        class: "box-item",
                        effect: "dark",
                        content: "仅win10及以上版本支持剪贴板历史记录",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(InfoFilled))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                align: "left",
                prop: "description",
                label: "简介",
                "show-overflow-tooltip": true
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleGenerate,
            disabled: props.taskGenerateStatus === 'processing'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.taskGenerateStatus ===
                'processing' ? '生成中...' : '生成'), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: handleClearSelection
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置")
            ]),
            _: 1
          }),
          (_unref(userInfo) && _unref(userInfo).priv === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(" Debug模式 "),
                _createVNode(_component_el_switch, {
                  modelValue: isDebug.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isDebug).value = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})